import { StopAPI } from '../../../api/datamanager/StopAPI';

export class StopsCommand {
    get(edition, providerId, computeLines, successCallback, errorCallback) {
        const apiResult = StopAPI.list(edition.network, providerId, computeLines);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((_) => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a ler as paragens");
            }
        });
    }

    getStopLines(edition, stopId, successCallback, errorCallback) {
        const apiResult = StopAPI.lines(edition.network, stopId);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    getStopMunicipality(edition, stopId, successCallback, errorCallback) {
        const apiResult = StopAPI.municipality(edition.network, stopId);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    getWithoutMapPoint(edition, providerId, successCallback, errorCallback) {
        const apiResult = StopAPI.listWithoutMapPoints(edition.network, providerId);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((_) => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a ler as paragens");
            }
        });
    }

    count(edition, providerId, successCallback, errorCallback) {
        const apiResult = StopAPI.countActive(edition.network, providerId);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    save(edition, stop, successCallback, errorCallback) {
        let apiResult = undefined;
        let successMessage = "";

        if (undefined === stop.id || 0 === stop.id) {
            apiResult = StopAPI.create(edition.network, [stop]);
            successMessage = "Paragem criada com sucesso";
        }
        else {
            apiResult = StopAPI.update(edition.network, stop.id, stop);
            successMessage = "Paragem editada com sucesso";
        }
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                const output = {
                    message: successMessage,
                    data: undefined
                };

                try { output.data = JSON.parse(result); }
                catch (_) { }

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    saveBulk(edition, stops, successCallback, errorCallback) {
        const apiResult = StopAPI.createStops(edition.network, stops);
        const successMessage = "Paragens criadas com sucesso";
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                const output = {
                    message: successMessage,
                    data: undefined
                };

                try { output.data = JSON.parse(result); }
                catch (_) { }

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    editBulk(edition, stops, successCallback, errorCallback) {
        const apiResult = StopAPI.updateStops(edition.network, stops);
        const successMessage = "Paragens editadas com sucesso";
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                const output = {
                    message: successMessage,
                    data: undefined
                };

                try { output.data = JSON.parse(result); }
                catch (_) { }

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    delete(edition, stopId, successCallback, errorCallback) {
        const apiResult = StopAPI.delete(edition.network, stopId);
        apiResult.then((_) => {
            if (undefined !== successCallback) {
                const output = {
                    message: "Paragem eliminada com sucesso",
                    data: undefined
                };

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    deleteBulk(edition, stops, successCallback, errorCallback) {
        const apiResult = StopAPI.deleteStops(edition.network, stops);
        apiResult.then((_) => {
            if (undefined !== successCallback) {
                const output = {
                    message: "Paragens eliminadas com sucesso",
                    data: undefined
                };

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/commands/StopsCommand.js